import Dev from './User/Dev';
import Home from './User/Home';
import CourierHome from './Courier/Home';
import CourierProfile from './Courier/Profile';
import RequestDetails from './Courier/RequestDetails';
import SignIn from './Auth/SignIn';
import SignUp from './Auth/SignUp';
import Onboarding from './Auth/Onboarding';
import ForgotPassword from './Auth/ForgotPassword';
import CreateNewPass from './Auth/CreateNewPass';
import SignupConfirmation from './Auth/SignupConfirmation';
import ResetPassConfirmation from './Auth/ResetPassConfirmation';
import ResetPassSuccess from './Auth/ResetPassSuccess';
import SignupVerif from './Auth/SignupVerif';
import OTP from './Auth/OTP';
import MyStorages from './User/MyStorages';
import StorageInfo from './User/StorageInfo';
import ItemDetails from './User/ItemDetails';
import RequestStorage from './User/RequestStorage';
import RequestOut from './User/RequestOut';
import RequestIn from './User/RequestIn';
import Market from './User/Market';
import MarketSearch from './User/MarketSearch';
import MarketMyBid from './User/MarketMyBid';
import MarketMyOrder from './User/MarketMyOrder';
import MarketSaleItem from './User/MarketSaleItem';
import MarketWatchlist from './User/MarketWatchlist';
import ProductDetails from './User/ProductDetails';
import RequestReturn from './User/RequestReturn';
import Profile from './User/Profile';
import History from './User/History';
import HistoryDetails from './User/HistoryDetails';
import Subscription from './User/Subscription';
import SubscriptionPackage from './User/SubscriptionPackage';
import OenoBank from './User/OenoBank';
import SubscriptionDetails from './User/SubscriptionDetails';
import SubscriptionSuccess from './User/SubscriptionSuccess';
import AddressList from './User/AddressList';
import UpdateAddress from './User/UpdateAddress';
import UpdateProfile from './User/UpdateProfile';
import SellProduct from './User/SellProduct';
import MySubscription from './User/MySubscription';
import RequestItem from './User/RequestItem';
import AdminHome from './Admin/Home';
import AdminRequestIn from './Admin/RequestIn';
import AdminRequestIn2 from './Admin/RequestIn2';
import AdminRequestOut2 from './Admin/RequestOut2';
import AdminRequestOut from './Admin/RequestOut';
import AdminStorages from './Admin/Storages';
import AdminStorages2 from './Admin/Storages2';
import AdminCouriers from './Admin/Couriers';
import AdminAddons from './Admin/Addons';
import AdminOverview from './Admin/Overview';
import AdminAllCouriers from './Admin/AllCouriers';
import UpdateCourier from './Admin/UpdateCourier';
import AdminMarketDetails from './Admin/MarketDetails';
import CourierDetails from './Admin/CourierDetails';
import CustomerDetails from './Admin/CustomerDetails';
import AdminDetails from './Admin/AdminDetails';
import ManageSubscriptions from './Admin/ManageSubscriptions';
import AdminSettings from './Admin/Settings';
import UpdateAdmin from './Admin/UpdateAdmin';
import ListMarket from './Admin/Market';
import ListMarketMyItems from './Admin/MarketMyItems';
import UpdateMarketItem from './Admin/UpdateMarketItem';
import AllAdmins from './Admin/AllAdmins';
import AllCustomers from './Admin/AllCustomers';
import AllTransactions from './Admin/AllTransactions';
import RequestedItems from './Admin/RequestedItems';
import RequestedItems2 from './Admin/RequestedItems2';
import RequestedItemDetails from './Admin/RequestedItemDetails';
import Notifications from './User/Notifications';
import Wallet from './User/Wallet';
import WalletPin from './User/WalletPin';
import WalletIntro from './User/WalletIntro';
import WalletTerms from './User/WalletTerms';
import WalletHistory from './User/WalletHistory';
import WalletHistoryDetails from './User/WalletHistoryDetails';
import WalletWithdraw from './User/WalletWithdraw';
import Cart from './User/Cart';
import PurchaseConfirmation from './User/PurchaseConfirmation';
import ExtraStorage from './User/ExtraStorage';
import ExtraStorageConfirmation from './User/ExtraStorageConfirmation';
import ContactUs from './User/ContactUs';
import Settings from './User/Settings';
import Language from './User/Language';
import SellMultiProduct from './User/SellMultiProduct';

const Pages = {
  SignIn,
  SignUp,
  Onboarding,
  ForgotPassword,
  CreateNewPass,
  SignupConfirmation,
  ResetPassConfirmation,
  ResetPassSuccess,
  SignupVerif,
  OTP,

  Dev,
  Home,
  MyStorages,
  StorageInfo,
  ItemDetails,
  RequestStorage,
  RequestOut,
  RequestIn,
  Market,
  MarketSearch,
  MarketMyBid,
  MarketMyOrder,
  MarketSaleItem,
  MarketWatchlist,
  ProductDetails,
  RequestReturn,
  Profile,
  History,
  HistoryDetails,
  Subscription,
  SubscriptionPackage,
  OenoBank,
  SubscriptionDetails,
  SubscriptionSuccess,
  AddressList,
  UpdateAddress,
  UpdateProfile,
  SellProduct,
  MySubscription,
  RequestItem,
  Notifications,
  Wallet,
  WalletPin,
  WalletIntro,
  WalletTerms,
  WalletHistory,
  WalletHistoryDetails,
  WalletWithdraw,
  Cart,
  PurchaseConfirmation,
  ExtraStorage,
  ExtraStorageConfirmation,
  ContactUs,
  Settings,
  Language,
  SellMultiProduct,

  CourierHome,
  RequestDetails,
  CourierProfile,

  AdminHome,
  AdminRequestIn,
  AdminRequestIn2,
  AdminRequestOut2,
  AdminRequestOut,
  AdminStorages,
  AdminStorages2,
  AdminCouriers,
  AdminAllCouriers,
  UpdateCourier,
  UpdateAdmin,
  ListMarket,
  ListMarketMyItems,
  UpdateMarketItem,
  AllAdmins,
  AllCustomers,
  AllTransactions,
  RequestedItems,
  RequestedItems2,
  RequestedItemDetails,
  AdminAddons,
  AdminOverview,
  CourierDetails,
  AdminMarketDetails,
  CustomerDetails,
  AdminDetails,
  ManageSubscriptions,
  AdminSettings,
};

export default Pages;
